import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Button, Typography } from '@percent/lemonade'
import { AuthSuccessTextProps } from './Auth.types'
import styles from './AuthSuccessText.module.scss'

export function AuthSuccessText({ text, showSignInLink = true, showSignInButton = false }: AuthSuccessTextProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const goToSignIn = () => navigate('/signin')

  return (
    <>
      <Typography className={styles.successText}>{text}</Typography>
      {showSignInLink && (
        <p className={styles.signInLink}>
          <Link to="/signin">{t('typography.nowSignInHere')}</Link>
        </p>
      )}
      {showSignInButton && (
        <div className={styles.signInButtonWrapper}>
          <Button stretch size="large" onClick={goToSignIn}>
            {t('typography.signInHere')}
          </Button>
        </div>
      )}
    </>
  )
}
